import { render, staticRenderFns } from "./ChildConfirmation.vue?vue&type=template&id=518d032b&"
import script from "./ChildConfirmation.vue?vue&type=script&lang=js&"
export * from "./ChildConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports